import Api from "../api";

import { PlasError } from "./models.jsx";

class ErrorsApi extends Api {
	
	get(errorId, callback) {
		var url = this.baseUrl + "/" + errorId;

		this.client.get(url)
			.then((response) => {
				callback({
					result: new PlasError(response.data),
					error: null
				});
			}).catch((error) => {
				callback({ 
		    		result: null, 
		    		error: this.extractError(error)
		    	});
			});
	}

	getPage(startItem, endItem, userId, service, operation, startDate, endDate, sort, callback) {
	
		var url = this.baseUrl;
	    this.client.get(url, { 
	    	headers: {"Range": "items=" + startItem + "-" + endItem},
	    	params: { userId: userId, sort: sort, service: service, operation: operation, startDate: startDate, endDate: endDate }
	    }).then((response) => {
			var rangeHeader = response.headers["range"];
			var total = parseInt(rangeHeader.split("/")[1]);

			var data = [];
			for (var index = 0; index < response.data.length; index++) {
				data.push(new PlasError(response.data[index]));
			}

	    	callback({ 
	    		result: { data: data, total: total }, 
	    		error: null
	    	});
	    }).catch((error) => {
	    	callback({ 
	    		result: null, 
	    		error: this.extractError(error)
	    	});
	    });
	}
}


export default ErrorsApi;